export const LANGUAGE = {
  KO: 'ko',
  EN: 'en',
};

export const DEFAULT_LANGUAGE = LANGUAGE.KO;

export const SUPPORTED_LANGUAGES = Object.values(LANGUAGE);

export const DEFAULT_USER_CONFIG = {
  i18n: {
    defaultLocale: DEFAULT_LANGUAGE,
    locales: SUPPORTED_LANGUAGES,
  },
};
